import first from 'lodash/first';
import tail from 'lodash/tail';

import type { FlatDrawers, Drawer } from '@virtuslab/nfs-shared/src/schema/user/drawerModels';
import type { Nullable } from '@virtuslab/nfs-shared/src/services/object';

export const toTree = (nodes: FlatDrawers): Nullable<Drawer> => {
  const currentNode = first(nodes) ?? null;

  if (currentNode === null) {
    return null;
  }

  return {
    ...currentNode,
    child: toTree(tail(nodes)),
  };
};

